import { useCallback, useState } from 'react';
import { Modal } from 'foundations-components/transitional/components/Modal';
import { DialogHeader } from 'foundations-components/transitional/components/DialogHeader';
import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import { DialogFooter } from 'foundations-components/transitional/components/DialogFooter';
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';
import { Button } from 'foundations-components/transitional/components/Button';
import { Text } from 'foundations-components/components/Text';
import { Alert } from 'foundations-components/transitional/components/Alert';
import BusinessUnitSelect from 'ui-business-units-lib/components/BusinessUnitSelect';
import WithBusinessUnitsDataFetching from 'ui-business-units-lib/utils/WithBusinessUnitsDataFetching';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const AccountBrandSelect = WithBusinessUnitsDataFetching(BusinessUnitSelect);
const BulkChangeBrandModal = ({
  onConfirm,
  onReject
}) => {
  const [selectedBrandId, setSelectedBrandId] = useState(undefined);
  const [saving, setSaving] = useState(false);
  const handleSave = useCallback(() => {
    if (selectedBrandId === undefined) {
      return;
    }
    setSaving(true);
    onConfirm(selectedBrandId).then(() => {
      setSaving(false);
    }).catch(() => {
      setSaving(false);
    });
  }, [selectedBrandId, onConfirm]);
  const handleChangeBrand = useCallback(id => {
    if (id === undefined) {
      return;
    }
    setSelectedBrandId(id);
  }, []);
  return /*#__PURE__*/_jsxs(Modal, {
    size: "auto",
    width: 500,
    children: [/*#__PURE__*/_jsxs(DialogHeader, {
      children: [/*#__PURE__*/_jsx(DialogCloseButton, {
        onClick: onReject
      }), /*#__PURE__*/_jsx(Text, {
        as: "h2",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "summary.header.buttons.changeBrand"
        })
      })]
    }), /*#__PURE__*/_jsxs(DialogBody, {
      children: [/*#__PURE__*/_jsx(Alert, {
        type: "info",
        marginBlockEnd: "400",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "bulkChangeBrandModal.alert"
        })
      }), /*#__PURE__*/_jsx(Text, {
        as: "label",
        marginBlockEnd: "100",
        display: "block",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "summary.brand.label"
        })
      }), /*#__PURE__*/_jsx(AccountBrandSelect, {
        buId: selectedBrandId,
        onChange: handleChangeBrand
      })]
    }), /*#__PURE__*/_jsxs(DialogFooter, {
      children: [/*#__PURE__*/_jsx(Button, {
        use: "primary",
        onClick: handleSave,
        disabled: saving || selectedBrandId === undefined,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "changeBrandModal.save"
        })
      }), /*#__PURE__*/_jsx(Button, {
        use: "tertiary-light",
        onClick: onReject,
        disabled: saving,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "changeBrandModal.cancel"
        })
      })]
    })]
  });
};
export default WithBusinessUnitsDataFetching(BulkChangeBrandModal);